<script>
export default {
  methods: {
    getGoogleAuthUrl() {
      // Ideally a request to /auth/google_oauth2 should be made
      // Creating the URL manually because the devise-token-auth with
      // omniauth has a standing issue on redirecting the post request
      // https://github.com/lynndylanhurley/devise_token_auth/issues/1466
      // Endpoint OFICIAL de autorização OAuth2 do Google. O antigo
      // `/o/oauth2/auth/oauthchooseaccount` é um caminho interno/legado e
      // retorna 400 "malformed" em contas/projetos novos.
      const baseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
      const clientId = window.chatwootConfig.googleOAuthClientId;
      const redirectUri = window.chatwootConfig.googleOAuthCallbackUrl;

      // Build the query string
      const queryString = new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'email profile',
        prompt: 'select_account',
      }).toString();

      // Construct the full URL
      return `${baseUrl}?${queryString}`;
    },
  },
};
</script>

<!-- eslint-disable vue/no-unused-refs -->
<!-- Added ref for writing specs -->
<template>
  <div class="flex flex-col">
    <a
      :href="getGoogleAuthUrl()"
      class="group inline-flex w-full items-center justify-center gap-3 rounded-xl border border-black/10 bg-white px-4 py-3 text-base font-semibold text-slate-800 shadow-sm transition-all duration-200 hover:-translate-y-px hover:shadow-md focus:outline-none focus:ring-2 focus:ring-black/10 active:translate-y-0"
    >
      <span
        class="i-logos-google-icon h-5 w-5 shrink-0 transition-transform duration-200 group-hover:scale-110"
      />
      <span>{{ $t('LOGIN.OAUTH.GOOGLE_LOGIN') }}</span>
    </a>
  </div>
</template>
